import React from 'react';
import {  Show,
ShowButton,List,EditButton,SimpleForm,
 Datagrid,RichTextInput,DisabledInput,TextInput,Edit,
TextField, RichTextField ,SimpleShowLayout,
ReferenceInput, SelectInput
 }
from 'admin-on-rest/lib/mui';

export const duplicateOneMonthList = (props) => (
    <List title="חיובים כפולים בכרטיס - חודשי" {...props}>
        <Datagrid>
        <TextField label="בית עסק" source="buisiness_id" />
        <TextField label="תאריך" source="date" />
            <TextField label="כרטיס אשראי" source="cc_id" />
             <TextField label="מספר עסקאות" source="count" />
             
             
            
  
        </Datagrid>
    </List>
);




              



// WEBPACK FOOTER //
// ./src/components/RiskManagement/DuplicateCards/duplicateOneMonth.js